import React, { useEffect, useMemo, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import colors from 'assets/variables/colors';
import { CvSkillsReviewPopupProps } from 'core/interface/cv-skills-review';
import CandidateSkillsForm from 'components/shared/CandidateSkills/CandidateSkillsForm';
import { uniqSkills } from 'utils/normalizeSkillList';

import 'components/shared/CandidateSkills/candidate-skills.scss';

const CvSkillsReviewPopup: React.FC<CvSkillsReviewPopupProps> = ({
  t,
  candidateId,
  isExtracting,
  existingHardSkills,
  existingSoftSkills,
  previewHardSkills,
  previewSoftSkills,
  onClose,
  onSaved
}) => {
  const initialHard = useMemo(
    () => uniqSkills(previewHardSkills),
    [previewHardSkills]
  );
  const initialSoft = useMemo(
    () => uniqSkills(previewSoftSkills),
    [previewSoftSkills]
  );

  const [formKey, setFormKey] = useState(0);

  useEffect(() => {
    if (!isExtracting) {
      setFormKey((key) => key + 1);
    }
  }, [isExtracting, initialHard, initialSoft]);

  if (isExtracting) {
    return (
      <Box className="cv-skills-review">
        <div className="cv-skills-review__loading">
          <CircularProgress size={48} sx={{ color: colors.tenantColor }} />
          <p>
            {t(
              'Our AI is extracting skills from your resume. This may take a moment.'
            )}
          </p>
        </div>
      </Box>
    );
  }

  return (
    <CandidateSkillsForm
      key={formKey}
      t={t}
      candidateId={candidateId}
      initialHardSkills={initialHard}
      initialSoftSkills={initialSoft}
      existingHardSkills={existingHardSkills}
      existingSoftSkills={existingSoftSkills}
      showLegend
      legendVariant="cv"
      onClose={onClose}
      onSaved={onSaved}
    />
  );
};

export default CvSkillsReviewPopup;
